import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart } from '../../redux/cartslice';
import { useNavigate } from 'react-router-dom';
import Context from '../../Context/Context';
import { toast } from 'react-toastify';
import Loader from '../../ApiCheck/Loader';
import { baseUrl } from '../../ApiCheck/Constant';

const Product = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [categories, setCategories] = useState(['All']);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (!user.isAuth) {
      navigate('/');
    }
  }, [user, navigate]);

  const { fetchCartCount } = useContext(Context);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${baseUrl}/api/product`);
      setProducts(response.data.data);
      setFilteredProducts(response.data.data);
      setCategories(['All', ...new Set(response.data.data.map(product => product.category))]);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch products. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const style = {
    width: "50%",
    height: "100%",
    objectFit: "cover",
    margin: "auto",
    cursor: 'pointer'
  };

  useEffect(() => {
    if(user.user.role === 'USER') {
    fetchProducts();
    fetchCartCount();
    }
  }, []);

  useEffect(() => {
    filterProducts(selectedCategory, searchTerm);
  }, [selectedCategory, searchTerm, products]);

  const filterProducts = (category, search) => {
    let filtered = products;
    if (category !== 'All') {
      filtered = filtered.filter(product => product.category === category);
    }
    if (search.trim() !== '') {
      const searchTermLower = search.trim().toLowerCase();
      filtered = filtered.filter(product =>
        product.name.toLowerCase().includes(searchTermLower) ||
        product.description.toLowerCase().includes(searchTermLower)
      );
    }
    setFilteredProducts(filtered);
  };

  const addToCartHandler = async (product) => {
    if (user.isAuth) {
      dispatch(addToCart(product));
      const payload = { ...product, quantity: 1 };
      await axios.post(`${baseUrl}/api/addtocart`, payload);
      toast.success("Product added to cart", { position: 'top-center', autoClose: 3000 });
      fetchCartCount();
    } else {
      toast.error("Please Login...", { position: 'top-center', autoClose: 3000 });
    }
  };

  const showProductDetails = (product) => {
    navigate(`/product/${product._id}`, { state: { product } });
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="container mt-4">
      <div className="row">

        <div className="col-md-3 mt-4">
          <h5>Categories</h5>
          <ul className="list-group">
            {categories.map((category, index) => (
              <li
                key={index}
                className={`list-group-item w-50 ${selectedCategory === category ? 'active' : ''}`}
                style={{ cursor: 'pointer' }}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </li>
            ))}
          </ul>
        </div>

        <div className="p-3 col-md-9">

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h1>Products</h1>
            <input
              type="text"
              className="form-control w-50"
              placeholder="Search products..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>


          {loading ? (
            <Loader />
          ) : (
            <div>

              {filteredProducts.length > 0 ? (
                <div className="row">
                  {filteredProducts.map((product, index) => (
                    <div className="col-md-4 col-sm-6 mb-3 p-2" key={index}>
                      <div className="card h-100 product-card">
                        <img
                          src={product.image}
                          className="card-img-top"
                          alt={product.name}
                          style={style}
                          onClick={() => showProductDetails(product)}
                        />
                        <div className="card-body d-flex flex-column">
                          <h5 className="card-title" onClick={() => showProductDetails(product)}>
                            {product.name}
                          </h5>
                          <p className="card-text">{product.description}</p>
                          <p className="card-price"><strong>Price: </strong>${product.price}</p>
                          <button
                            type="button"
                            className="btn btn-dark mt-auto"
                            onClick={() => addToCartHandler(product)}
                          >
                            Add to Cart
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p>No products found.</p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Product;
